<ng-container *transloco="let t; read: 'import-into-configuration-drawer-component'">
  <xi-drawer
    #drawer
    [open]="open()"
    [interceptClose]="true"
    (onClose)="cancel()"
    color="CX"
    [silverBg]="true"
  >
    <div slot="title">{{ t('page-title') }}</div>
    <div slot="body" class="import-into-configuration__body">
      @if (!inputFile()) {
        <h2>{{ t('update-header') }}</h2>
        <p>
          {{ t('select-guide') }}
        </p>
      } @else {
        <h2>{{ t('update-header-upload') }}</h2>
        <p>
          {{ t('select-guide-upload') }}
        </p>
      }

      <hr />

      @if (isSaving) {
        <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
          <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
        </div>
      }

      <div class="import-into-configuration__content">
        <div class="import-into-configuration__content-column">
          @if (!inputFile()) {
            <div>
              <h3>{{ t('select-a-config') }}</h3>
            </div>
            @if (isLoading) {
              <div>
                <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
              </div>
            }
            <div class="import-into-configuration__content-controls">
              <div class="import-into-configuration__scroll">
                @if (industryPacks?.length) {
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title> {{ t('industry-packs') }} </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-action-list>
                      @for (pack of industryPacks; track pack) {
                        <button
                          (click)="selectSourceConfig(pack, 'pack')"
                          class="import-into-configuration__template-row"
                          [class.import-into-configuration__template-row--selected]="
                            selectedSourceConfigId === pack.id
                          "
                        >
                          <app-configuration-pill templateType="pack"></app-configuration-pill>
                          {{ pack.name }}
                        </button>
                      }
                    </mat-action-list>
                  </mat-expansion-panel>
                }
                @for (groupEntry of configsByGroup | keyvalue; track groupEntry) {
                  <mat-expansion-panel [expanded]="groupEntry.key.group_id === groupId()">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ groupEntry.key.group_name }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-action-list>
                      @for (source of groupEntry.value; track source) {
                        <button
                          (click)="selectSourceConfig(source, 'configuration')"
                          class="import-into-configuration__template-row"
                          [class.import-into-configuration__template-row--selected]="
                            selectedSourceConfigId === source.id
                          "
                        >
                          <app-configuration-pill
                            templateType="configuration"
                          ></app-configuration-pill>
                          {{ source.name }}
                        </button>
                      }
                    </mat-action-list>
                  </mat-expansion-panel>
                }
              </div>
            </div>
          } @else {
            <div>
              <h3>{{ t('source-file') }}</h3>
              <table class="import-into-configuration__source-file">
                <thead>
                  <th>{{ t('file-name') }}</th>
                  <th>{{ t('type') }}</th>
                  <th>{{ t('size') }}</th>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ fileName }}</td>
                    <td>{{ fileType }}</td>
                    <td>{{ inputFile().size | humanizeInt }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="import-into-configuration__change-source">
                <span (click)="cancel(true)">{{ t('use-a-different-file') }}</span>
              </div>
            </div>
            <div class="import-into-configuration__form-section--field"></div>
          }
        </div>

        <div class="import-into-configuration__content-column">
          <h3>
            {{ t('action') }}
            <span
              ngbPopover="{{ t('action-popover') }}"
              triggers="mouseenter:mouseleave"
              placement="right"
            >
              <xi-icon-button icon="info" color="orca" buttonSize="large"></xi-icon-button>
            </span>
          </h3>

          <div class="import-into-configuration__content-controls">
            <div class="import-into-configuration__scroll">
              <mat-form-field class="full-width">
                <mat-select
                  name="action"
                  [(ngModel)]="action"
                  [disabled]="!sourceConfiguration()"
                  (selectionChange)="onActionChanged()"
                >
                  <mat-option value="merge">{{ t('merge') }}</mat-option>
                  <mat-option value="override">{{ t('override') }}</mat-option>
                </mat-select>
              </mat-form-field>

              <app-configuration-content-form
                [configurationDto]="sourceConfiguration()"
                [configurationSettings]="targetConfiguration().settings"
                [configurationTaxonomy]="resultingConfiguration?.taxonomies"
                [accountLimits]="accountLimits()"
                [configurationCounts]="itemCounts"
                (formChange)="onConfigIncludeChanged($event)"
                (accountFeatureCheck)="onAccountFeatureChecked($event)"
              ></app-configuration-content-form>
            </div>
          </div>
        </div>

        <div class="import-into-configuration__content-column">
          <h3>{{ t('current-configuration-preview') }}</h3>

          <div
            class="import-into-configuration__content-controls import-into-configuration__preview"
          >
            <div class="import-into-configuration__scroll">
              <div class="import-into-configuration__preview-name">
                {{ resultingConfiguration.name }}
              </div>

              @for (item of configItems; track item) {
                <div
                  class="import-into-configuration__preview-item"
                  [class.import-into-configuration__preview-item--included]="
                    configIncludeData.includes[item.prop]
                  "
                >
                  {{ item.label }} ({{ item.count }})
                </div>
              }

              <div class="import-into-configuration__preview-notes">
                {{ resultingConfiguration.notes }}
              </div>

              <div class="import-into-configuration__preview-tags">
                <app-tag-editor
                  [editable]="false"
                  [removable]="false"
                  [configuration]="resultingConfiguration"
                ></app-tag-editor>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (missingAccountFeatures.length) {
        <div class="import-into-configuration__errors">
          {{ t('detected-settings', { count: missingAccountFeatures.length }) }}
          <span [matTooltip]="missingAccountFeatures.join('\n')"></span>
        </div>
      }
    </div>

    <div slot="footer" class="import-into-configuration__actions">
      <xi-default-button
        text="{{ t('cancel') }}"
        fill="text"
        [disabled]="isSaving"
        (onClick)="cancel()"
      ></xi-default-button>

      <div class="xi-loader-button-container">
        <div [matTooltip]="configIncludeData?.tooltip">
          <xi-default-button
            text="{{ t('import') }}"
            [disabled]="!canConfirmImport()"
            (onClick)="confirmImport()"
          >
          </xi-default-button>
        </div>

        @if (isSaving) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>
    </div>
  </xi-drawer>

  <!-- Move Configuration Modal-->
  @if (showConfirmImport) {
    <app-lex-xi-modal [isVisible]="showConfirmImport" (close)="onConfirmImportClosed()">
      <ng-template appXIModalContent>
        @if (showConfirmImport) {
          <app-import-configuration-confirm-dialog
            [data]="confirmDialogData"
            (modalClosed)="onConfirmImportClosed($event)"
          ></app-import-configuration-confirm-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
